<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link v-if="p_idPerfil == 18 || p_idPerfil == 20" to="/tramite-asignados">Trámites</router-link>
              <router-link v-else to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Observaciones</li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer" @click="showModalHelp = true">
          help
        </span>
      </div>
    </div>
<div class="card border-0 mb-3" style="background-color: #e8f4fd;">
  <div class="card-body py-2 px-3">
    <span class="text-dark fw-bold">{{ datosTramite }}</span>
  </div>
</div>
    <!-- Tabs -->
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item" v-for="tab in tabs" :key="tab">
        <a class="nav-link" :class="{ active: activeTab === tab }"
          href="#" @click.prevent="activeTab = tab">
          {{ tab }}
        </a>
      </li>
    </ul>

    <!-- Barra de acciones -->
    <div class="row g-2 align-items-center mb-3">
      <div v-if="p_idPerfil == 17" class="col-auto">
        <label class="form-label mb-0 small fw-bold">Estado AM</label>
        <select v-model="filtros.estadoAud" class="form-select form-select-sm">
          <option value="">Todos</option>
          <option value="PENDIENTE">Pendiente</option>
          <option value="REVISADA">Revisada</option>
          <option value="FINALIZADA">Finalizada</option>
        </select>
      </div>
      <div v-if="p_idPerfil == 19" class="col-auto">
        <label class="form-label mb-0 small fw-bold">Estado GD</label>
        <select v-model="filtros.estadoDoc" class="form-select form-select-sm">
          <option value="">Todos</option>
          <option value="PENDIENTE">Pendiente</option>
          <option value="REVISADA">Revisada</option>
          <option value="FINALIZADA">Finalizada</option>
        </select>
      </div>
      <div v-if="p_idPerfil == 17" class="col-auto">
        <label class="form-label mb-0 small fw-bold">Obs. AM Rep.</label>
        <select v-model="filtros.obsAudRep" class="form-select form-select-sm">
          <option :value="null">Todos</option>
          <option value="0">Pendientes</option>
          <option value="1">Enviados</option>
        </select>
      </div>
      <div v-if="p_idPerfil == 19" class="col-auto">
        <label class="form-label mb-0 small fw-bold">Obs. GD Rep.</label>
        <select v-model="filtros.obsDocRep" class="form-select form-select-sm">
          <option :value="null">Todos</option>
          <option value="0">Pendientes</option>
          <option value="1">Enviados</option>
        </select>
      </div>
      <div class="col-auto">
        <button @click="buscarDatos"
          class="btn btn-primary btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">search</span> Buscar
        </button>
      </div>
      <div class="col-auto">
        <button @click="registrarDatos"
          class="btn btn-danger btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">save</span> Registrar
        </button>
      </div>
      <div class="col-auto">
        <button @click="exportToCSV"
          class="btn btn-success btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">download</span> CSV
        </button>
      </div>
      <div class="col-auto">
        <button @click="exportToExcel"
          class="btn btn-info btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">download</span> Excel
        </button>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <!-- Tab: Observaciones combinadas -->
    <div v-else-if="activeTab === 'Observaciones combinadas'">

      <h6 class="fw-bold mb-2">Observaciones generales</h6>
      <div class="table-responsive" v-if="resultadosGenerales.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('generales', 'planillaNumero')">
                Planilla <span>{{ iconOrden('generales', 'planillaNumero') }}</span>
              </th>
              <th>Código</th>
              <th class="th-sort" @click="ordenarPor('generales', 'observacionDescripcion')">
                Observación estándar <span>{{ iconOrden('generales', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('generales', 'descripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'estadoAud')">
                Estado AM <span>{{ iconOrden('generales', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('generales', 'estadoDoc') }}</span>
              </th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.generales.planilla" @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th></th>
              <th>
                <input v-model="filtrosColumna.generales.obsEstandar" @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.generales.obsComplementaria" @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.generales.estadoAud" @change="resetPagina('generales')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.generales.estadoDoc" @change="resetPagina('generales')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedGenerales" :key="r.id">
              <td>{{ r.planillaNumero }}</td>
              <td></td>
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="6" class="text-end fw-bold small">
                Mostrando {{ pagedGenerales.length }} de {{ generalesFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-2 mb-4">No se encontraron observaciones generales.</div>

      <!-- Paginación generales -->
      <div class="d-flex justify-content-between align-items-center mt-2 mb-4"
        v-if="generalesFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageGenerales }} de {{ totalPagesGenerales }} —
          {{ generalesFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageGenerales === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('generales')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageGenerales, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageGenerales = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === totalPagesGenerales }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === totalPagesGenerales }">
              <a class="page-link" href="#"
                @click.prevent="currentPageGenerales = totalPagesGenerales">»</a>
            </li>
          </ul>
        </nav>
      </div>

      <h6 class="fw-bold mb-2">Observaciones detalle</h6>
      <div class="table-responsive" v-if="resultadosDetalle.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('detalle', 'planillaNumero')">
                Planilla <span>{{ iconOrden('detalle', 'planillaNumero') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'elementoCodigo')">
                Código <span>{{ iconOrden('detalle', 'elementoCodigo') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'observacionDescripcion')">
                Observación estándar <span>{{ iconOrden('detalle', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('detalle', 'descripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'estadoAud')">
                Estado AM <span>{{ iconOrden('detalle', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('detalle', 'estadoDoc') }}</span>
              </th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.detalle.planilla" @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.codigo" @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.obsEstandar" @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.obsComplementaria" @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.detalle.estadoAud" @change="resetPagina('detalle')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.detalle.estadoDoc" @change="resetPagina('detalle')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedDetalle" :key="r.id">
              <td>{{ r.planillaNumero }}</td>
              <td>{{ r.elementoCodigo }}</td>
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="6" class="text-end fw-bold small">
                Mostrando {{ pagedDetalle.length }} de {{ detalleFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-2">No se encontraron observaciones detalle.</div>

      <!-- Paginación detalle -->
      <div class="d-flex justify-content-between align-items-center mt-2"
        v-if="detalleFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageDetalle }} de {{ totalPagesDetalle }} —
          {{ detalleFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageDetalle === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('detalle')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageDetalle, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageDetalle = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === totalPagesDetalle }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === totalPagesDetalle }">
              <a class="page-link" href="#"
                @click.prevent="currentPageDetalle = totalPagesDetalle">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Tab: Generales o Detalle -->
    <div v-else>
      <div class="table-responsive" v-if="resultados.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('main', 'planillaNumero')">
                Planilla <span>{{ iconOrden('main', 'planillaNumero') }}</span>
              </th>
              <th v-if="activeTab !== 'Observaciones generales'"
                class="th-sort" @click="ordenarPor('main', 'elementoCodigo')">
                Código <span>{{ iconOrden('main', 'elementoCodigo') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'observacionDescripcion')">
                Observación estándar <span>{{ iconOrden('main', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('main', 'descripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'estadoAud')">
                Estado AM <span>{{ iconOrden('main', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('main', 'estadoDoc') }}</span>
              </th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.main.planilla" @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th v-if="activeTab !== 'Observaciones generales'">
                <input v-model="filtrosColumna.main.codigo" @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.main.obsEstandar" @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.main.obsComplementaria" @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.main.estadoAud" @change="resetPagina('main')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.main.estadoDoc" @change="resetPagina('main')"
                  class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedResultados" :key="r.id">
              <td>{{ r.planillaNumero }}</td>
              <td v-if="activeTab !== 'Observaciones generales'">{{ r.elementoCodigo }}</td>
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td :colspan="activeTab === 'Observaciones generales' ? 5 : 6"
                class="text-end fw-bold small">
                Mostrando {{ pagedResultados.length }} de {{ mainFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-3">No se encontraron resultados.</div>

      <!-- Paginación principal -->
      <div class="d-flex justify-content-between align-items-center mt-3"
        v-if="mainFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageMain }} de {{ totalPagesMain }} —
          {{ mainFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageMain === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageMain = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageMain--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('main')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageMain, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageMain = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === totalPagesMain }">
              <a class="page-link" href="#" @click.prevent="currentPageMain++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === totalPagesMain }">
              <a class="page-link" href="#"
                @click.prevent="currentPageMain = totalPagesMain">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import dateFormat from "@/modules/dateFormat.js";
import api from "@/services/api";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

export default {
  name: "ObservacionesTabs",
  props: {
    p_idtramite: { type: Number, required: true }
  },
  components: { Layout, Footer },
  data() {
    return {
      tabs: ["Observaciones generales", "Observaciones detalle", "Observaciones combinadas"],
      activeTab: "Observaciones generales",
      p_idPerfil: 0,
      filtros: { observacionTipo: "", estadoAud: "", estadoDoc: "", obsAudRep: null, obsDocRep: null },
      resultados: [],
      resultadosGenerales: [],
      resultadosDetalle: [],
      cargando: false,
      itemsPerPage: 10,
      currentPageMain: 1,
      currentPageGenerales: 1,
      currentPageDetalle: 1,
      datosTramite: "",
      orden: {
        main:      { campo: 'planillaNumero', ascendente: true },
        generales: { campo: 'planillaNumero', ascendente: true },
        detalle:   { campo: 'planillaNumero', ascendente: true },
      },
      filtrosColumna: {
        main:      { planilla: '', codigo: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' },
        generales: { planilla: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' },
        detalle:   { planilla: '', codigo: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' },
      },
    };
  },
  computed: {
    mainFiltrados() {
      const fc = this.filtrosColumna.main;
      const esGenerales = this.activeTab === 'Observaciones generales';
      const lista = this.resultados.filter(r => {
        const p  = fc.planilla              ? String(r.planillaNumero ?? '').toLowerCase().includes(fc.planilla.toLowerCase())            : true;
        const c  = (!esGenerales && fc.codigo) ? String(r.elementoCodigo ?? '').toLowerCase().includes(fc.codigo.toLowerCase())          : true;
        const oe = fc.obsEstandar           ? String(r.observacionDescripcion ?? '').toLowerCase().includes(fc.obsEstandar.toLowerCase()) : true;
        const oc = fc.obsComplementaria     ? String(r.descripcion ?? '').toLowerCase().includes(fc.obsComplementaria.toLowerCase())      : true;
        const ea = fc.estadoAud             ? (r.estadoAud ?? '') === fc.estadoAud                                                        : true;
        const ed = fc.estadoDoc             ? (r.estadoDoc ?? '') === fc.estadoDoc                                                        : true;
        return p && c && oe && oc && ea && ed;
      });
      return this._ordenarLista(lista, this.orden.main);
    },
    totalPagesMain() {
      return Math.max(1, Math.ceil(this.mainFiltrados.length / this.itemsPerPage));
    },
    pagedResultados() {
      const start = (this.currentPageMain - 1) * this.itemsPerPage;
      return this.mainFiltrados.slice(start, start + this.itemsPerPage);
    },
    generalesFiltrados() {
      const fc = this.filtrosColumna.generales;
      const lista = this.resultadosGenerales.filter(r => {
        const p  = fc.planilla          ? String(r.planillaNumero ?? '').toLowerCase().includes(fc.planilla.toLowerCase())                        : true;
        const oe = fc.obsEstandar       ? String(r.observacionDescripcion ?? '').toLowerCase().includes(fc.obsEstandar.toLowerCase())             : true;
        const oc = fc.obsComplementaria ? String(r.descripcion ?? '').toLowerCase().includes(fc.obsComplementaria.toLowerCase())                  : true;
        const ea = fc.estadoAud         ? (r.estadoAud ?? '') === fc.estadoAud                                                                    : true;
        const ed = fc.estadoDoc         ? (r.estadoDoc ?? '') === fc.estadoDoc                                                                    : true;
        return p && oe && oc && ea && ed;
      });
      return this._ordenarLista(lista, this.orden.generales);
    },
    totalPagesGenerales() {
      return Math.max(1, Math.ceil(this.generalesFiltrados.length / this.itemsPerPage));
    },
    pagedGenerales() {
      const start = (this.currentPageGenerales - 1) * this.itemsPerPage;
      return this.generalesFiltrados.slice(start, start + this.itemsPerPage);
    },
    detalleFiltrados() {
      const fc = this.filtrosColumna.detalle;
      const lista = this.resultadosDetalle.filter(r => {
        const p  = fc.planilla          ? String(r.planillaNumero ?? '').toLowerCase().includes(fc.planilla.toLowerCase())                        : true;
        const c  = fc.codigo            ? String(r.elementoCodigo ?? '').toLowerCase().includes(fc.codigo.toLowerCase())                          : true;
        const oe = fc.obsEstandar       ? String(r.observacionDescripcion ?? '').toLowerCase().includes(fc.obsEstandar.toLowerCase())             : true;
        const oc = fc.obsComplementaria ? String(r.descripcion ?? '').toLowerCase().includes(fc.obsComplementaria.toLowerCase())                  : true;
        const ea = fc.estadoAud         ? (r.estadoAud ?? '') === fc.estadoAud                                                                    : true;
        const ed = fc.estadoDoc         ? (r.estadoDoc ?? '') === fc.estadoDoc                                                                    : true;
        return p && c && oe && oc && ea && ed;
      });
      return this._ordenarLista(lista, this.orden.detalle);
    },
    totalPagesDetalle() {
      return Math.max(1, Math.ceil(this.detalleFiltrados.length / this.itemsPerPage));
    },
    pagedDetalle() {
      const start = (this.currentPageDetalle - 1) * this.itemsPerPage;
      return this.detalleFiltrados.slice(start, start + this.itemsPerPage);
    },
  },
  watch: {
    activeTab() {
      this.currentPageMain = 1;
      this.currentPageGenerales = 1;
      this.currentPageDetalle = 1;
      this.filtrosColumna.main      = { planilla: '', codigo: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' };
      this.filtrosColumna.generales = { planilla: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' };
      this.filtrosColumna.detalle   = { planilla: '', codigo: '', obsEstandar: '', obsComplementaria: '', estadoAud: '', estadoDoc: '' };
      this.buscarDatos();
    },
  },
  mounted() {
    this.p_idPerfil = window.sessionStorage.getItem("idPerfil");
    this.filtros.observacionTipo = this.p_idPerfil == 17 ? "M" : "D";
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.buscarDatos();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // ── Ordenamiento ──────────────────────────────────────
    ordenarPor(tabla, campo) {
      if (this.orden[tabla].campo === campo) {
        this.orden[tabla].ascendente = !this.orden[tabla].ascendente;
      } else {
        this.orden[tabla].campo = campo;
        this.orden[tabla].ascendente = true;
      }
      this.resetPagina(tabla);
    },
    iconOrden(tabla, campo) {
      if (this.orden[tabla].campo !== campo) return '⇅';
      return this.orden[tabla].ascendente ? '↑' : '↓';
    },
_ordenarLista(lista, orden) {
  const { campo, ascendente } = orden;
  return [...lista].sort((a, b) => {
    const va = a[campo] ?? "";
    const vb = b[campo] ?? "";

    // ── Ordenamiento numérico para planillaNumero ────────
    if (campo === 'planillaNumero') {
      const na = parseFloat(va);
      const nb = parseFloat(vb);
      if (!isNaN(na) && !isNaN(nb)) {
        return ascendente ? na - nb : nb - na;
      }
    }

    // ── Ordenamiento alfabético para el resto ────────────
    const cmp = String(va).localeCompare(String(vb), "es");
    return ascendente ? cmp : -cmp;
  });
},
    resetPagina(tabla) {
      if (tabla === 'main')      this.currentPageMain      = 1;
      if (tabla === 'generales') this.currentPageGenerales = 1;
      if (tabla === 'detalle')   this.currentPageDetalle   = 1;
    },
    paginasVisibles(tabla) {
      const mapaTotal  = { main: this.totalPagesMain,  generales: this.totalPagesGenerales,  detalle: this.totalPagesDetalle  };
      const mapaActual = { main: this.currentPageMain, generales: this.currentPageGenerales, detalle: this.currentPageDetalle };
      const total  = mapaTotal[tabla];
      const actual = mapaActual[tabla];
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
    // ── Datos ─────────────────────────────────────────────
    async buscarDatos() {
      this.cargando = true;
      if (this.activeTab === "Observaciones combinadas") {
        await this.fetchCombinadas();
      } else {
        const endpoint = this.activeTab === "Observaciones generales"
          ? "/vwplaobss/buscar"
          : "/vwpladetobss/buscar";
        try {
          const { data } = await api.get(endpoint, {
            params: {
              idTramite:       this.p_idtramite,
              observacionTipo: this.filtros.observacionTipo || null,
              estadoAud:       this.filtros.estadoAud || null,
              obsAudRep:       this.filtros.obsAudRep,
              estadoDoc:       this.filtros.estadoDoc || null,
              obsDocRep:       this.filtros.obsDocRep,
            }
          });
          this.resultados = Array.isArray(data) ? data : [];
          this.currentPageMain = 1;
        } catch (e) {
          console.error("Error al cargar datos:", e);
          this.resultados = [];
        } finally {
          this.cargando = false;
        }
      }
    },
    async fetchCombinadas() {
      try {
        const params = {
          idTramite:       this.p_idtramite,
          observacionTipo: this.filtros.observacionTipo || null,
          estadoAud:       this.filtros.estadoAud || null,
          obsAudRep:       this.filtros.obsAudRep,
          estadoDoc:       this.filtros.estadoDoc || null,
          obsDocRep:       this.filtros.obsDocRep,
        };
        const [generales, detalle] = await Promise.all([
          api.get("/vwplaobss/buscar",    { params }),
          api.get("/vwpladetobss/buscar", { params }),
        ]);
        this.resultadosGenerales = Array.isArray(generales.data) ? generales.data : [];
        this.resultadosDetalle   = Array.isArray(detalle.data)   ? detalle.data   : [];
        this.currentPageGenerales = 1;
        this.currentPageDetalle   = 1;
      } catch (e) {
        console.error("Error al cargar datos combinados:", e);
        this.resultadosGenerales = [];
        this.resultadosDetalle   = [];
      } finally {
        this.cargando = false;
      }
    },
    async registrarDatos() {
      const result = await Swal.fire({
        title: "¿Registrar datos?",
        text: "Se actualizarán las planillas revisadas. ¿Deseas continuar?",
        icon: "question", showCancelButton: true,
        confirmButtonText: "Sí", cancelButtonText: "No", reverseButtons: true,
      });
      if (result.isConfirmed) {
        try {
          const { data } = await api.post("/procedimientos/actualizar-planillas-revisadas", {}, {
            params: { idTramite: this.p_idtramite, tipo: this.p_idPerfil == 17 ? "AUD" : "DOC" },
          });
          await Swal.fire({ title: "Éxito", text: "Registro realizado correctamente.", icon: "success", confirmButtonText: "OK" });
          console.log("Respuesta del backend:", data);
          this.buscarDatos();
        } catch (e) {
          console.error("Error al registrar datos:", e);
          await Swal.fire({ title: "Error", text: e.response?.data || "Ocurrió un problema.", icon: "error", confirmButtonText: "Cerrar" });
        }
      }
    },
    exportToCSV() {
      if (this.activeTab === "Observaciones combinadas") {
        if (this.resultadosGenerales.length === 0 && this.resultadosDetalle.length === 0) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const headers = ["Número","Cédula","Nombre","Fecha desde","Fecha hasta","Fecha atención","Código","Descripción","Observación estándar","Observación complementaria","Estado A.M.","Estado G.D."];
        const csvContent = [
          "\uFEFF" + headers.join(";"),
          ...this.resultadosGenerales.map(row =>
            [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
             this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
             "", "", "",
             row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]
            .map(v => `"${v.toString().replace(/"/g,'""')}"`)
            .join(";")),
          ...this.resultadosDetalle.map(row =>
            [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
             this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
             this.getFormattedDate(row.fechaAtencion)||"", row.elementoCodigo||"", row.elementoNombre||"",
             row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]
            .map(v => `"${v.toString().replace(/"/g,'""')}"`)
            .join(";"))
        ].join("\n");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }));
        link.setAttribute("download", `observaciones_combinadas_${this.p_idtramite}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
      } else {
        if (this.resultados.length === 0) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const esGen = this.activeTab === "Observaciones generales";
        const headers = ["Número","Cédula","Nombre","Fecha desde","Fecha hasta","Fecha atención","Código","Descripción","Observación estándar","Observación complementaria","Estado A.M.","Estado G.D."];
        const csvContent = [
          "\uFEFF" + headers.join(";"),
          ...this.resultados.map(row =>
            [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
             this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
             esGen ? "" : this.getFormattedDate(row.fechaAtencion)||"",
             esGen ? "" : row.elementoCodigo||"",
             esGen ? "" : row.elementoNombre||"",
             row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]
            .map(v => `"${v.toString().replace(/"/g,'""')}"`)
            .join(";"))
        ].join("\n");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }));
        link.setAttribute("download", `observaciones_${this.p_idtramite}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
      }
    },
    exportToExcel() {
      const headers = ["Número","Cédula","Nombre","Fecha desde","Fecha hasta","Fecha atención","Código","Descripción","Observación estándar","Observación complementaria","Estado A.M.","Estado G.D."];
      if (this.activeTab === "Observaciones combinadas") {
        if (this.resultadosGenerales.length === 0 && this.resultadosDetalle.length === 0) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const data = [
          ...this.resultadosGenerales.map(row =>
            [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
             this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
             "", "", "",
             row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]),
          ...this.resultadosDetalle.map(row =>
            [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
             this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
             this.getFormattedDate(row.fechaAtencion)||"", row.elementoCodigo||"", row.elementoNombre||"",
             row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]),
        ];
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
        XLSX.writeFile(wb, `observaciones_combinadas_${this.p_idtramite}.xlsx`);
      } else {
        if (this.resultados.length === 0) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const esGen = this.activeTab === "Observaciones generales";
        const data = this.resultados.map(row =>
          [row.planillaNumero||"", row.planillaCedula||"", row.planillaNombre||"",
           this.getFormattedDate(row.planillaFechaDesde)||"", this.getFormattedDate(row.planillaFechaHasta)||"",
           esGen ? "" : this.getFormattedDate(row.fechaAtencion)||"",
           esGen ? "" : row.elementoCodigo||"",
           esGen ? "" : row.elementoNombre||"",
           row.observacionDescripcion||"", row.descripcion||"", row.estadoAud||"", row.estadoDoc||""]);
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
        XLSX.writeFile(wb, `observaciones_${this.p_idtramite}.xlsx`);
      }
    },
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>

<style scoped>
/* ── Tabs ── */
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}

/* ── Tabla ── */
.table-hover tbody tr {
  cursor: pointer;
}

/* ── Encabezados ordenables ── */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}

/* ── Fila de filtros de columna ── */
thead tr:nth-child(2) th {
  cursor: default;
  font-weight: normal;
  padding: 4px 6px;
}
thead tr:nth-child(2) th input,
thead tr:nth-child(2) th select {
  font-weight: normal;
  color: #212529;
}
</style>